import React, { useState, useEffect } from 'react'
import './index.less'
import { fanhui } from '@/assets/images'
import RhymeCompare from './RhymeCompare/index'
import MethodCompare from './MethodCompare/index'
import FormCompare from './FormCompare/index'
import ColorCompare from './ColorCompare/index'
import PositionCompare from './PositionCompare/index'
import ImitationCompare from './ImitationCompare/index'
import MiniMap from '@/components/MiniMap'
import { useAppSelector, useAppDispatch } from '@/hooks'
import { getCompareImgsInfoByImgID, getCompareInfo, getPaintingIntro } from '@/server'
import {
  setClass1,
  setClass2,
  setClass3,
  setDescription,
  setMaterialType,
  setMediaType,
  setStyleType
} from '@/features/SetPaintingIntroInfo/setPaintingIntroInfo'
import {
  setAtrID,
  setColorBar,
  setDate,
  setGlobalTags,
  setGlobalTagTree,
  setLocalInfo,
  setLocalTagTree,
  setRecommend,
  setShowType,
  setTime
} from '@/features/SetCompareInfo/setCompareInfo'
import { LOADIPHLPAPI as _LOADIPHLPAPI } from 'dns'
import { setToken } from '@/features/Login/login'
import { useNavigate } from 'react-router-dom'
import { setSelectedComparison } from '@/features/SetAnalysisImageInfo/setAnalysisImageInfo'
// 分析页面(左侧)传移默写
interface _similarImgsI {
  uuid: string
  sim: number
}
export interface similarImgsInfoI {
  title: string
  similarity: number
  author: string
  imgSrc: string
  dynasty: string
}
export default function ComparePanel() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const token = useAppSelector((state) => state.login.token)
  // 从搜索框得到的imageId和workId
  const imageId = useAppSelector((state) => state.compareImageInfo.imageId)
  const workId = useAppSelector((state) => state.compareImageInfo.workId)
  const class1 = useAppSelector((state) => state.paintingIntroInfo.class1) //主题
  // 六种方法：0气韵生动 1骨法用笔 2应物象形 3随类赋彩 4经营位置 5传移模写
  // const setShowPanel = props.setShowPanel
  // const { selectedComparison, setSelectedComparison } = props
  const selectedComparison = useAppSelector((state) => state.analysisImageInfo.selectedComparison)
  // console.log(selectedComparison, "selectedComparison")

  //瓦片地图相关信息
  const [tilesPath, setTilesPath] = useState<string>('')
  const [width, setWidth] = useState<number>(0)
  const [height, setHeight] = useState<number>(0)
  const [levelMax, setLevelMax] = useState<number>(0)
  const [levelMin, setLevelMin] = useState<number>(0)
  useEffect(() => {
    console.log('compareid:', imageId)
  }, [imageId])

  useEffect(() => {
    getCompareInfo(token, imageId).then((res) => {
      if (res.data.code === '10056') {
        //token失效
        window.confirm('登录已过期，请重新登录！')
        dispatch(setToken(''))
        navigate('/')
      } else {
        if (res.data.atrID !== undefined) dispatch(setAtrID(res.data.atrID))
        if (res.data.date !== undefined) dispatch(setDate(res.data.date))
        if (res.data.time !== undefined) dispatch(setTime(res.data.time))
        if (res.data.globalTagTree !== undefined) dispatch(setGlobalTagTree(res.data.globalTagTree))
        if (res.data.localTagTree !== undefined) dispatch(setLocalTagTree(res.data.localTagTree))
        if (res.data.globalTags !== undefined) dispatch(setGlobalTags(res.data.globalTags))
        if (res.data.localInfo !== undefined) dispatch(setLocalInfo(res.data.localInfo))
        if (res.data.colorBar !== undefined) dispatch(setColorBar(res.data.colorBar))
        if (res.data.recommend !== undefined) dispatch(setRecommend(res.data.recommend))
      }
    })
    //根据imageId拿取瓦片地图相关信息
    getCompareImgsInfoByImgID(token, { imageId: imageId }).then((res) => {
      if (res.data.code === '10056') {
        //token失效
        window.confirm('登录已过期，请重新登录！')
        dispatch(setToken(''))
        navigate('/')
      } else {
        if (res.data.content.tilesPath !== undefined) setTilesPath(res.data.content.tilesPath)
        if (res.data.content.width !== undefined) setWidth(res.data.content.width)
        if (res.data.content.height !== undefined) setHeight(res.data.content.height)
        if (res.data.content.tileslevelmin !== undefined)
          setLevelMin(res.data.content.tileslevelmin)
        if (res.data.content.tileslevelmax !== undefined)
          setLevelMax(res.data.content.tileslevelmax - 1)
      }
    })
  }, [dispatch, imageId])
  //通过workid拿取简介信息等相关数据
  useEffect(() => {
    if (workId.length > 0) {
      getPaintingIntro(token, {
        workId: workId
      }).then((res) => {
        if (res.data.code === '10056') {
          //token失效
          window.confirm('登录已过期，请重新登录！')
          dispatch(setToken(''))
          navigate('/')
        } else {
          // console.log(res.data.content, ">")
          if (res.data.content.class1 !== null) {
            dispatch(setClass1(res.data.content.class1))
            console.log(res.data.content.class1, 'compareclass1')
          }
          if (res.data.content.class2 !== null) {
            dispatch(setClass2(res.data.content.class2))
          }
          if (res.data.content.mediatype !== null) {
            dispatch(setMediaType(res.data.content.mediatype))
          }
          if (res.data.content.styletype !== null) {
            dispatch(setStyleType(res.data.content.styletype))
          }
          if (res.data.content.class3 !== null) {
            dispatch(setClass3(res.data.content.class3))
          }
          if (res.data.content.materialtype !== null) {
            dispatch(setMaterialType(res.data.content.materialtype))
          }
          if (res.data.content.description !== null) {
            dispatch(setDescription(res.data.content.description))
          }

          // setAuthorName(res.data.content?.authorname || "佚名")
        }
      })
    }
  }, [dispatch, workId])

  // 获取传移默写信息
  const recommend = useAppSelector((state) => state.compareInfo.recommend)
  // console.log(recommend, "comparerecommend")

  const [similarImgsInfo, setSimilarImgsInfo] = useState<similarImgsInfoI[]>([])
  useEffect(() => {
    //recommend改变时发送请求，获取图像具体信息
    const dataArr: Promise<any>[] = []
    for (let i = 1; i < recommend.length; i++) {
      if (i >= 21) break
      dataArr.push(
        getCompareImgsInfoByImgID(token, {
          imageId: recommend[i].uuid
        })
      )
    }
    const newSimilarImgsInfo: similarImgsInfoI[] = []
    const simImgs = Promise.all(dataArr).then((values) => {
      for (let i = 0; i < values.length; i++) {
        if (values[i].data.content !== null) {
          const currentSimilarImgInfo: similarImgsInfoI = {
            title: values[i].data.content.workname,
            similarity: Number(recommend[i + 1].sim.toFixed(2)) * 100,
            author: values[i].data.content.authorname,
            imgSrc: values[i].data.content.encoding,
            dynasty: values[i].data.content.dynasty
          }
          newSimilarImgsInfo.push(currentSimilarImgInfo)
        }
      }
      setSimilarImgsInfo(newSimilarImgsInfo)
    })
    return () => {
      simImgs.then(() => {
        setSimilarImgsInfo([])
      })
    }
  }, [recommend])
  const handleReselect = () => {
    dispatch(setShowType(1))
  }
  // useEffect(() => {
  //   //recommend改变时发送请求，获取图像具体信息
  //   const dataArr: Promise<any>[] = []
  //   for (let i = 1; i < recommend.length; i++) {
  //     if (i >= 21) break
  //     dataArr.push(
  //       getCompareImgsInfoByImgID({
  //         imageId: recommend[i].uuid
  //       })
  //     )
  //   }
  //   const newSimilarImgsInfo: similarImgsInfoI[] = []
  //   Promise.all(dataArr).then((values) => {
  //     for (let i = 0; i < values.length; i++) {
  //       let currentSimilarImgInfo: similarImgsInfoI = {
  //         title: values[i].data.content.workname,
  //         similarity: Number(recommend[i + 1].sim.toFixed(2)) * 100,
  //         author: values[i].data.content.authorname,
  //         imgSrc: values[i].data.content.encoding,
  //         dynasty: values[i].data.content.dynasty
  //       }
  //       newSimilarImgsInfo.push(currentSimilarImgInfo)
  //     }
  //     setSimilarImgsInfo(newSimilarImgsInfo)
  //   })
  // }, [recommend])
  // const handleReselect = () => {
  //   dispatch(setShowType(1))
  // }
  return (
    <div className='compare-panel'>
      <div className='compare-head'>
        <div
          className={'compare-head-item ' + (selectedComparison === 0 ? 'item-selected' : '')}
          onClick={(_e) => dispatch(setSelectedComparison(0))}
        >
          气韵生动
        </div>
        <div
          className={'compare-head-item ' + (selectedComparison === 1 ? 'item-selected' : '')}
          onClick={(_e) => dispatch(setSelectedComparison(1))}
        >
          骨法用笔
        </div>
        <div
          className={'compare-head-item ' + (selectedComparison === 2 ? 'item-selected' : '')}
          onClick={(_e) => dispatch(setSelectedComparison(2))}
        >
          应物象形
        </div>
        <div
          className={'compare-head-item ' + (selectedComparison === 3 ? 'item-selected' : '')}
          onClick={(_e) => dispatch(setSelectedComparison(3))}
        >
          随类赋彩
        </div>
        <div
          className={'compare-head-item ' + (selectedComparison === 4 ? 'item-selected' : '')}
          onClick={(_e) => dispatch(setSelectedComparison(4))}
        >
          经营位置
        </div>
        <div
          className={'compare-head-item ' + (selectedComparison === 5 ? 'item-selected' : '')}
          onClick={(_e) => dispatch(setSelectedComparison(5))}
        >
          传移模写
        </div>
      </div>
      <div className='compare-minimap'>
        <MiniMap
          tilesPath={tilesPath}
          width={width}
          height={height}
          levelMax={levelMax}
          levelMin={levelMin}
          displayType={1}
        />
      </div>
      <div className='compare-reselect'>
        <img src={fanhui} alt='' onClick={handleReselect} />
      </div>
      {/* <div className="compare-body">
        
      </div> */}
      {selectedComparison === 0 ? (
        <RhymeCompare />
      ) : selectedComparison === 1 ? (
        <MethodCompare />
      ) : selectedComparison === 2 ? (
        <FormCompare />
      ) : selectedComparison === 3 ? (
        <ColorCompare />
      ) : selectedComparison === 4 ? (
        <PositionCompare class1={class1} />
      ) : selectedComparison === 5 ? (
        <ImitationCompare similarImgsInfo={similarImgsInfo} />
      ) : (
        <></>
      )}
    </div>
  )
}
